import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const SaveListingModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "SaveListingModalContainer" */
      './SaveListingModalContainer.dynamic'
    ),
  loading: () => <div />,
});
